<template>
    <li></li>
</template>

<script>
    export default {
        name: 'SeparatorListItem'
    }
</script>

<style lang="scss" scoped>
    $color: #3c6286;

    li {
        background-color: $color !important;
        border-bottom: 1px solid $color !important;
        height: 5px;
        cursor: default !important;
    }
</style>
